'use es6';

import { List, Set as ImmutableSet } from 'immutable';
import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { getPubSubMessage } from 'conversations-message-history/unpublished-messages/operators/getPubSubMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { threadHistoryToMessageList } from 'conversations-message-history/thread-history/operators/threadHistoryToMessageList';
import InitialMessage from 'conversations-visitor-message-history/initial-message/InitialMessage';
import ThemeConfigProvider from 'conversations-visitor-message-history/theming/providers/ThemeConfigProvider';
import { FIRST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { buildMessageHistoryTheme } from 'conversations-visitor-message-history/utils/buildMessageHistoryTheme';
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import get from 'transmute/get';
import CommonMessage from 'conversations-visitor-message-history/common-message/CommonMessage';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import { getPositionDescriptors } from 'conversations-message-history/message-history/operators/getPositionDescriptors';
import { ChatWidgetLocaleContextConsumer } from '../../visitor-widget/ChatWidgetLocaleContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChatFeedWrapper = styled.div.withConfig({
  displayName: "ChatFeedSimple__ChatFeedWrapper",
  componentId: "sc-1w0r187-0"
})(["width:100%;padding:12px 4px;max-height:100%;overflow-y:scroll;> div{flex-shrink:0;}"]);
class ChatFeedSimple extends Component {
  renderPublishedMessagesTail(messages, locale) {
    const {
      senders,
      mobile
    } = this.props;
    return messages.toSeq().map((message, index) => {
      if (index === 0) {
        // Initial Message has already rendered
        return null;
      }
      const previousMessage = index > 0 ? messages.get(index - 1) : undefined;
      const nextMessage = messages.get(index + 1);
      const positionDescriptors = getPositionDescriptors(message, previousMessage, nextMessage, false);
      const hasUnansweredQuickReplyMessage = !nextMessage && message.metadata && message.metadata.quickReply && message.metadata.quickReply.quickReplies && message.metadata.quickReply.quickReplies.size > 0;
      return /*#__PURE__*/_jsx(CommonMessage, {
        hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage,
        isThreadStarted: true,
        message: message,
        nextMessage: get(index + 1, message),
        onAttachmentLoad: () => {},
        positionDescriptors: positionDescriptors,
        requiresExplicitConsentToProcess: false,
        fileAttachments: List(),
        senders: senders,
        mobile: mobile,
        locale: locale
      }, getId(message));
    });
  }
  render() {
    const {
      threadHistory,
      coloring,
      senders,
      mobile
    } = this.props;
    const messages = threadHistoryToMessageList(threadHistory);
    const pubSubMessage = getPubSubMessage(messages.get(0));
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsx(ChatFeedWrapper, {
        className: "flex-column add-flex-grow",
        children: /*#__PURE__*/_jsxs(ThemeConfigProvider, {
          themeConfig: buildMessageHistoryTheme({
            coloring
          }),
          children: [/*#__PURE__*/_jsx(InitialMessage, {
            message: pubSubMessage,
            isThreadStarted: true,
            chatHeadingConfig: this.props.chatHeadingConfig,
            positionDescriptors: ImmutableSet([FIRST]),
            sendFromResponders: this.props.sendFromResponders,
            senders: senders,
            requiresExplicitConsentToProcess: false,
            mobile: mobile
          }), this.renderPublishedMessagesTail(messages, locale)]
        })
      })
    });
  }
}
ChatFeedSimple.displayName = 'ChatFeedSimple';
ChatFeedSimple.propTypes = {
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  coloring: PropTypes.object.isRequired,
  mobile: PropTypes.bool,
  sendFromResponders: PropTypes.instanceOf(List),
  senders: SenderMap,
  threadHistory: RecordPropType('ThreadHistory')
};
export default ChatFeedSimple;